<template>
  <div class="freightTable">
    <div class="content" v-if="tableList && tableList.length > 0">
      <div class="table" v-for="(table, index) in tableList" :key="index">
        <van-collapse v-model="activeNames">
          <van-collapse-item
            :name="index"
            :disabled="isCustomer"
            :class="isCustomer ? 'customer-item' : ''"
          >
            <template #title>
              <div class="table-title">
                <div class="table-title-left">
                  <span v-if="language == 'zh'">{{ table.CargoCategory }}</span>
                  <span v-else>{{ table.CargoCategoryEn }}</span>
                </div>
                <div class="table-title-right">
                  {{ table.CurrencySymbol }}{{ table.TotalFreight }}
                </div>
              </div>
              <div class="table-subTitle">
                <div class="table-item">
                  {{ $t.calculator.col2 }}：{{ table.FirstWeight
                  }}<span v-if="table.WeightUnit == 1">KG</span
                  ><span v-if="table.WeightUnit == 2">cbm</span>
                </div>
                <div class="table-item">
                  {{ $t.calculator.col3 }}：{{ table.CurrencySymbol
                  }}{{ table.FirstWeightPrice }}
                </div>
                <div class="table-item">
                  {{ $t.calculator.col4 }}：{{ table.ContinuousWeight
                  }}<span v-if="table.WeightUnit == 1">KG</span
                  ><span v-if="table.WeightUnit == 2">cbm</span>
                </div>
                <div class="table-item">
                  {{ $t.calculator.col5 }}：{{ table.CurrencySymbol
                  }}{{ table.ContinuousWeightPrice }}
                </div>
                <div class="table-item">
                  {{ $t.calculator.col6 }}：{{ table.TransportationDuration
                  }}{{ $t.calculator.day }}
                </div>
                <div class="table-remark" v-if="table.Remark">
                  {{ $t.calculator.remark }}：
                  <span v-if="language == 'zh'">{{ table.Remark }}</span>
                  <span v-else>{{ table.RemarkEn }}</span>
                </div>
              </div>
            </template>

            <van-row
              class="table-row"
              v-for="(text, idx) in table.FreightCalculationDetailedExplanationList"
              :key="idx"
            >
              <van-col span="24">{{ text }}</van-col>
            </van-row>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
    <div v-else class="emptyTable">{{ $t.calculator.empty }}</div>
  </div>
</template>
<script>
import Vue from "vue";
import { Button, Row, Col, Collapse, CollapseItem } from "vant";

Vue.use(Button).use(Row).use(Col).use(Collapse).use(CollapseItem);
export default {
  name: "freightTable",
  components: {},
  props: {
    tableList: {
      type: Array,
    },
    isCustomer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      language: localStorage.getItem("requestLanguage") || "auto",
      activeNames: [],
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.freightTable {
  .content {
    ::v-deep .van-collapse-item__title {
      border: none !important;
      display: inline-block;
      text-align: center;
    }
    ::v-deep .van-collapse-item__content {
      padding: 20px 40px;
    }
    .van-collapse-item {
      ::v-deep .van-icon {
        margin-top: 10px;
        margin-left: 0px;
      }
      ::v-deep .van-cell {
        border-top: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
      }
    }
    .customer-item {
      ::v-deep .van-cell__right-icon {
        display: none !important;
      }
    }
    .table {
      margin: 2% auto auto auto;
      box-shadow: 0px 2.5px 6.5px 1px rgba(0, 0, 0, 0.1);
      .table-title {
        font-size: 14px;
        .table-title-left {
          width: 50%;
          display: inline-block;
          text-align: left;
          color: #323233;
          vertical-align: top;
        }
        .table-title-right {
          width: 50%;
          display: inline-block;
          text-align: right;
          color: #028ef3;
          vertical-align: top;
        }
      }
      .table-subTitle {
        padding-top: 1%;
        font-size: 11px;
        color: #999;
        text-align: left;
        .table-item {
          width: 32.33%;
          padding-right: 1%;
          padding-top: 1%;
          display: inline-block;
          vertical-align: top;
        }
        .table-remark {
          width: 100%;
          padding-right: 1%;
          padding-top: 1%;
          display: inline-block;
        }
      }
    }
    .table-row {
      margin-bottom: 10px;
      .van-col {
        text-align: left;
        font-size: 12px;
      }
    }
  }
  .emptyTable {
    color: #999;
    font-size: 14px;
    text-align: center;
    padding: 20%;
    border: 1px solid #ebedf0;
  }
}
</style>
